<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-box" /> Produtos
        </h2>
        <small class="text-muted">Gerencie produtos, preços e estoques.</small>
      </div>
      <div class="col-md-6 text-right">
        <button
          v-if="productCreateEdit"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="storeProduct()"
        >
          <i class="fas fa-plus" /> Adicionar Produto
        </button>

        <router-link
          class="btn btn-primary"
          style="margin-left: 5px"
          to="/categorias"
        >
          <i class="fas fa-list" /> Categorias
        </router-link>

        <template>
          <router-link
            v-if="!enabledStock && stockTransactionIndex"
            class="btn btn-primary disabled"
            style="margin-left: 5px"
            to="/estoque"
          >
            <i class="fas fa-box" /> Controlar Estoque
          </router-link>

          <router-link
            v-if="enabledStock && stockTransactionIndex"
            class="btn btn-primary"
            style="margin-left: 5px"
            to="/estoque"
          >
            <i class="fas fa-box" /> Controlar Estoque
          </router-link>
        </template>

        <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
          <b-dropdown-item @click="openProductsReport()"
            ><i class="fas fa-print mr-2"></i>Imprimir Relatório
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="goToTags()"
            ><i class="fas fa-barcode mr-2"></i>Imprimir Etiquetas
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="gerarCarga()"
            ><i class="fas fa-balance-scale mr-2"></i>Gerar Carga
            Balança</b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="exportProducts()"
            ><i class="fas fa-file-excel mr-2"></i>Exportar Para
            Excel</b-dropdown-item
          >
   
        </b-dropdown>
      </div>
    </div>

    <hr />

    <collapse-of-the-product-filter
      ref="collapseOfTheProductFilter"
      v-model="searchParams"
      @filter="select()"
    />

    <div class="row">
      <div class="col-12">
        <new-product-alert />
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-12">
        <component
          :is="gridMode"
          :products="products"
          @pagechange="select($event)"
          @storeProduct="storeProduct($event)"
        />
      </div>
    </div>

    <error-handler :error="error" />

    <product-form ref="productForm" @stored="select" />
  </div>
</template>

<script>
import ProductForm from "@/components/product/forms/ProductForm";
import newProductAlert from "@/components/product/sections/NewProductAlert";
import ProductList from "../components/product/lists/ProductList";
import ProductGrid from "../components/product/lists/ProductGrid";
import Filters from "./../mixins/Filters.js";
import CollapseOfTheProductFilter from "../components/product/filter/CollapseOfTheProductFilter";

export default {
  components: {
    ProductForm,
    newProductAlert,
    ProductList,
    ProductGrid,
    CollapseOfTheProductFilter,
  },

  data: function () {
    return {
      visible: false,
      gridMode: "ProductList",

      searchParams: {
        page: null,
        status: 1,
      },

      error: null,
    };
  },

  mounted() {
    this.select();
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    enabledStock() {
      if (this.$store.state.company.module_stock_active == 1) {
        return true;
      }
    },

    products() {
      return this.$store.state.products.products.products;
    },
    export_product() {
      return this.$store.state.products.export_product;
    },
    cargaTXT() {
      return this.$store.state.products.cargaTXT;
    },
    //permissions
    productCreateEdit() {
      return this.$acl.can("productCreateEdit");
    },
    stockTransactionIndex() {
      return this.$acl.can("stockTransactionIndex");
    },
  },

  methods: {
    select(page = 1) {
      this.searchParams.page = page;

      console.log(this.searchParams);

      this.$store.commit("showLoading");
      this.$store
        .dispatch("products/getProducts", this.searchParams)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    storeProduct(id = null, index = null) {
      if (this.productCreateEdit) {
        this.$refs.productForm.open(id);
      }
    },

    gerarCarga() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("products/getCargaTXT")
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([this.cargaTXT.data])
          );
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "Itensmgv.txt");
          document.body.appendChild(link);
          link.click();

          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    exportProducts() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("products/exportProducts")
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([this.export_product.data])
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Produtos.xlsx");
          document.body.appendChild(link);
          link.click();
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },

    goToTags() {
     this.$router.push("/produtos/etiquetas");
    },
    openProductsReport() {
      window.open("/produtos/relatorio");
    },
  },
};
</script>
